import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Hide, Rectangle, Shadow, Show, Space, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import ScorecardInning from './scorecard-inning';

const Scorecard = ({ scorecard, overview, teamId }) => {
  const { toss, innings, gameType } = scorecard;

  const renderInning = (inning, inningNo) => {
    const team =
      inning.ha === 'h'
        ? { ...overview.home, id: teamId }
        : { ...overview.away, oppositionTeamId: teamId };
    return (
      <ScorecardInning
        gameType={gameType}
        team={team}
        {...inning}
        key={`${inningNo}-${inning.ha}`}
      />
    );
  };

  return (
    <>
      {toss && (
        <Space bottom="large">
          <Shadow>
            <Rectangle radius="rounded" fill="white">
              <Cushion horizontal="medium" vertical={18}>
                <Typography color="black" preset="name" component="div" align="center">
                  <Show maxWidth="palm">
                    <Cushion botom="small" component="div">
                      <Icon name="toss" size={18} color="primary" />
                    </Cushion>
                  </Show>
                  <Hide maxWidth="palm">
                    <Cushion right="xsmall" component="span">
                      <Icon name="toss" size={18} color="primary" topOffset={4} />
                    </Cushion>
                  </Hide>
                  {toss}
                </Typography>
              </Cushion>
            </Rectangle>
          </Shadow>
        </Space>
      )}
      {innings.map((inning, i) => renderInning(inning, i + 1))}
    </>
  );
};

Scorecard.propTypes = {
  scorecard: PropTypes.shape({
    innings: PropTypes.arrayOf(PropTypes.shape()),
    gameType: PropTypes.oneOf(['standard', 'pairs']).isRequired,
    toss: PropTypes.string,
  }).isRequired,
  overview: PropTypes.shape({
    away: PropTypes.shape(),
    home: PropTypes.shape(),
  }).isRequired,
  teamId: PropTypes.number.isRequired,
};
export default Scorecard;
